const sectionSelector = '#MainContent > .shopify-section';

function isRevealEligible(section) {
  if (!(section instanceof HTMLElement)) return false;
  if (section.querySelector('.ch-hero, .ch-hero-mobile')) return false;
  if (section.matches('.shopify-section-group-header-group, .shopify-section-group-footer-group')) return false;
  if (section.querySelector('#ch-cart-drawer, .averoak-cookie-banner, shopify-privacy-banner')) return false;
  return section.offsetHeight > 24;
}

function revealSections() {
  if (document.querySelector('main[data-template*="product"]')) {
    document.querySelectorAll(sectionSelector).forEach((section) => {
      section.classList.add('averoak-reveal-visible');
      section.style.opacity = '1';
      section.style.transform = 'none';
      section.style.filter = 'none';
    });
    return;
  }

  const sections = Array.from(document.querySelectorAll(sectionSelector)).filter(isRevealEligible);
  if (!sections.length) return;

  sections.forEach((section, index) => {
    section.classList.add('averoak-reveal-init');
    section.style.setProperty('--averoak-reveal-delay', `${Math.min(index * 0.045, 0.18)}s`);
  });

  if (!('IntersectionObserver' in window)) {
    sections.forEach((section) => section.classList.add('averoak-reveal-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('averoak-reveal-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.12,
    }
  );

  sections.forEach((section) => observer.observe(section));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', revealSections, { once: true });
} else {
  revealSections();
}

document.addEventListener('shopify:section:load', () => {
  window.requestAnimationFrame(revealSections);
});

function initFeaturedProducts(section) {
  if (!(section instanceof HTMLElement) || section.dataset.chFeaturedReady === 'true') return;

  const track = section.querySelector('.ch-feat__track');
  if (!track) return;

  section.dataset.chFeaturedReady = 'true';
  const getGap = () => {
    const styles = window.getComputedStyle(track);
    const rawGap = parseFloat(styles.columnGap || styles.gap || '0');
    return Number.isFinite(rawGap) ? rawGap : 0;
  };
  const cardW = () => {
    const firstCard = track.querySelector('.ch-feat__card');
    return firstCard ? firstCard.getBoundingClientRect().width + getGap() : 352;
  };
  const prevButtons = Array.from(section.querySelectorAll('[id^="ch-feat-prev-"], [id^="ch-feat-mobile-prev-"]'));
  const nextButtons = Array.from(section.querySelectorAll('[id^="ch-feat-next-"], [id^="ch-feat-mobile-next-"]'));
  const updateControls = () => {
    const maxScrollLeft = Math.max(track.scrollWidth - track.clientWidth - 2, 0);
    const atStart = track.scrollLeft <= 4;
    const atEnd = track.scrollLeft >= maxScrollLeft;
    const isScrollable = track.scrollWidth > track.clientWidth + 6;

    prevButtons.forEach((button) => {
      button.disabled = !isScrollable || atStart;
      button.classList.toggle('is-disabled', !isScrollable || atStart);
    });

    nextButtons.forEach((button) => {
      button.disabled = !isScrollable || atEnd;
      button.classList.toggle('is-disabled', !isScrollable || atEnd);
    });
  };

  prevButtons.forEach((button) => button.addEventListener('click', () => {
    track.scrollBy({ left: -cardW(), behavior: 'smooth' });
  }));

  nextButtons.forEach((button) => button.addEventListener('click', () => {
    track.scrollBy({ left: cardW(), behavior: 'smooth' });
  }));

  section.querySelectorAll('.ch-feat-atc').forEach((button) => {
    button.addEventListener('click', () => {
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = button.dataset.loadingText || originalText;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((response) => response.json())
        .then(() => {
          button.textContent = button.dataset.addedText || originalText;
          document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        })
        .catch(() => {
          button.textContent = originalText;
          button.disabled = false;
        });
    });
  });

  track.addEventListener('scroll', updateControls, { passive: true });
  window.addEventListener('resize', updateControls);
  updateControls();
}

async function hydrateMissingFeaturedProducts() {
  const wrapper = document.querySelector('[id^="shopify-section-template--"][id$="__ch_featured_products"]');
  if (!wrapper || wrapper.querySelector('.ch-feat')) return;

  const sectionId = wrapper.id.replace('shopify-section-', '');
  const url = new URL(window.location.href);
  url.search = '';
  url.searchParams.set('sections', sectionId);

  try {
    const response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) return;

    const sections = await response.json();
    const html = sections && sections[sectionId];
    if (!html || !html.includes('ch-feat__card')) return;

    const template = document.createElement('template');
    template.innerHTML = html.trim();
    const replacement = template.content.firstElementChild;
    if (!(replacement instanceof HTMLElement)) return;

    wrapper.replaceWith(replacement);
    initFeaturedProducts(replacement.querySelector('.ch-feat'));
    window.requestAnimationFrame(revealSections);
  } catch (_) {
    // Keep the cached homepage usable even if the section request is blocked.
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hydrateMissingFeaturedProducts, { once: true });
} else {
  hydrateMissingFeaturedProducts();
}
